import React, { Component } from 'react';
import { calculateDuration, listToProjet } from '../api/timeListProcess';
import {colorToHex} from '../api/color';

class Projectbarchart extends Component {

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.currentWeek.length > 0 || ( this.props.currentWeek.length > 0 && nextProps.currentWeek.length === 0 ) ){
            return true
        }else{
            return false
        }
    }

    render() {
    this.spanList = []
    this.allRecordsInSecond = (calculateDuration(this.props.currentWeek, true));
    this.projectedList = listToProjet(this.props.currentWeek);
    for(let project in this.projectedList){
        let index = this.projectedList[project];
        let width = (calculateDuration(index, true)/this.allRecordsInSecond*100).toFixed(0)
        let color = colorToHex(index[0].project.color);

        this.spanList.push(<span key={index[0].project.id} style={ {flex: width + ' 1 0%', borderColor:color, color:color} }>{index[0].project.name}</span>)
    }

    return (
      <div className="project-bar-chart">
        { this.spanList }
      </div>
    );
  }
}

Projectbarchart.defaultProps = {
    currentWeek : []
}

export default Projectbarchart;
